import { Outlet } from "react-router-dom";
import Footer from "../Components/Common/Footer";
import Header from "../Components/Common/Header";

function WebRoute() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

export default WebRoute;
